export default "__VITE_ASSET__Dp9uTKtF__"